import React, {useState} from 'react';
import Logo from 'components/ui/icon/Logo';
import Container from 'components/layout/Container';
import {CenterContainer} from '../CentrContainer/CenterContainer';
import {useAnalytics} from 'contexts/Analytics';
import useMediaQuery from 'hooks/useMediaQuery';
import {useEffect} from 'react';

import './footer.scss';

const NUMBER = '+7 495 230-58-84';
const NUMBER_MASK_PREFIX = '+7 495';
const NUMBER_MASK_SUFFIX = 'ххх-хх-хх';

const Footer = () => {
  const {handleEvent} = useAnalytics();

  const isMobile = useMediaQuery('(max-width: 600px)');
  const [numberIsVisible, setNumberIsVisible] = useState(() => isMobile);

  useEffect(() => {
    setNumberIsVisible(isMobile);
  }, [isMobile]);

  const numberPrefix = numberIsVisible
    ? NUMBER.split(' ').slice(0, 2).join(' ')
    : NUMBER_MASK_PREFIX;
  const numberSuffix = numberIsVisible
    ? NUMBER.split(' ').slice(2).join(' ')
    : NUMBER_MASK_SUFFIX;

  const onClickCapture =
    isMobile || !numberIsVisible ? handleEvent('show_number') : null;

  return (
    <CenterContainer className={'center-container center-container--footer'}>
      <footer className="footer">
        <Container extraClassName="footer__wrapper">
          <div className="footer__logo-section">
            <Logo extraClassName="footer__logo" />

            <p className="footer__info">
              Руки подбирают мастеров, не&nbsp;являясь исполнителем ремонта
            </p>
          </div>

          <div className="footer__app-section">
            <p className="footer__info">
              Следите за&nbsp;заказом в&nbsp;приложении
            </p>

            <div className="footer__buttons-list">
              <a
                href="https://go.onelink.me/app/5d00e56e"
                className="footer__button footer__button_apple"
              >
                <span className="visually-hidden">AppStore</span>
              </a>

              <a
                href="https://go.onelink.me/app/9c87f611"
                className="footer__button footer__button_google"
              >
                <span className="visually-hidden">GooglePlay</span>
              </a>

              <a
                href="https://appgallery.huawei.com/app/C104454319"
                className="footer__button footer__button_huawei"
              >
                <span className="visually-hidden">AppGallery</span>
              </a>
            </div>
          </div>

          <div
            className="footer__phone-section"
            onClickCapture={onClickCapture}
            onClick={() => setNumberIsVisible(true)}
          >
            <p
              className={`footer__info ${
                numberIsVisible ? 'footer__info_visible' : ''
              }`}
            >
              {numberIsVisible ? 'Телефон' : 'Показать телефон'}
            </p>

            {numberIsVisible ? (
              <a
                href={`tel:${NUMBER}`}
                className="footer__phone footer__phone_visible"
              >
                {numberPrefix} {numberSuffix}
              </a>
            ) : (
              <span className="footer__phone">
                {numberPrefix}{' '}
                <span className="footer__phone_suffix">{numberSuffix}</span>
              </span>
            )}
          </div>
        </Container>
      </footer>
    </CenterContainer>
  );
};

export default Footer;
